import styled from "styled-components";

export const Container = styled.section`
    width: 100%;
    padding: 40px 0 20px;
    transition: 0.2s;
    @media screen and (max-width: 1140px){
        padding: 40px 20px 20px;
    }
`
export const Wrap = styled.div`
    max-width: 1140px;
    margin: 0 auto;
`

export const SubTitle = styled.p`
    line-height: 20px;
    font-size: 16px;
    text-transform: uppercase;
    letter-spacing: 5px;
    padding-bottom: 33px;
    position: relative;
    text-align: center;
    margin-top: 20px;
`

export const List = styled.ul`
    display: flex;
    align-items: stretch;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        flex-direction: column;
        gap: 44px;
        padding-bottom: 40px;
    }
`
export const ListItem = styled.li`
    
    width: calc(100% / 2);
    transition: 0.2s;
    @media screen and (max-width: 767px){
        width: 100%;
    }
`
export const Link = styled.a`
    padding: 22px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    @media screen and (max-width: 767px){
        padding: 0;
    }
`
export const ItemImg = styled.img`
    height: 80px;
`
export const ItemHook = styled.a`
    color: #00a0e7;
    font-size: 20px;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 0;
    
`
export const InfoWrap = styled.div`
    display: flex;
    gap: 30px;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        flex-direction: column;
    }
`
export const TextWrap = styled.div`
    width: calc((100% - 30px) / 2);
    display: flex;
    flex-direction: column;
    gap: 20px;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        width: 100%;
    }
`
export const Text = styled.p`
    font-size: 17px;
    color: #777777;
    line-height: 1.66em;
`

